import _ from 'lodash';

const getCheckedValues = (options) => {
    const checkedOptions = _.filter(options, (option) => option.checked);
    return _.map(checkedOptions, (option) => option.value);
};

const getCheckedIndices = (options) => {
    return _.filter(
        _.map(options, (option, index) => {
            return option.checked ? index : -1;
        }),
        (index) => index >= 0
    );
};

export {
    getCheckedValues,
    getCheckedIndices
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/checkboxGroupUtils.es6